import React from 'react';
import { Link } from 'react-router-dom';

const Pricing: React.FC = () => {
  const packages = [
    {
      name: "Starter Package",
      price: "$100",
      description: "Perfect for small businesses and startups who want a clean, simple logo.",
      features: [
        "1 Logo Design Concept",
        "2 Revisions",
        "Logo in PNG & JPG formats",
        "Basic Brand Guidelines",
        "Delivery in 3-5 business days"
      ],
      popular: false,
      color: "bg-gray-50"
    },
    {
      name: "Professional Package",
      price: "$250",
      description: "Best for growing brands that need a consistent look and feel.",
      features: [
        "3 Logo Design Concepts",
        "5 Revisions",
        "Logo in all formats (PNG, JPG, SVG, PDF)",
        "Complete Brand Guidelines",
        "Business Card Design",
        "Social Media Kit",
        "Delivery in 5-7 business days"
      ],
      popular: true,
      color: "bg-brand-blue"
    },
    {
      name: "Premium Package",
      price: "$350",
      description: "For businesses looking for a strong, lasting identity.",
      features: [
        "5 Logo Design Concepts",
        "Unlimited Revisions",
        "Logo in all formats (PNG, JPG, SVG, PDF, AI)",
        "Comprehensive Brand Guidelines",
        "Business Card Design",
        "Letterhead Design",
        "Social Media Kit",
        "Brand Style Guide",
        "Delivery in 7-10 business days"
      ],
      popular: false,
      color: "bg-gray-50"
    }
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Logo Design & Visual Identity Packages
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the perfect package for your business needs. All packages include professional design and fast delivery.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {packages.map((pkg, index) => (
            <div key={index} className={`relative rounded-2xl p-8 border-2 transition-all duration-300 hover:shadow-lg ${
              pkg.popular 
                ? 'border-brand-orange shadow-lg transform scale-105' 
                : 'border-gray-200 hover:border-brand-blue'
            }`}>
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-brand-orange text-white px-6 py-2 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <div className="text-4xl font-black text-brand-blue mb-4">{pkg.price}</div>
                <p className="text-gray-600">{pkg.description}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {pkg.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <svg className="w-5 h-5 text-brand-orange mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact" className={`w-full py-3 px-6 rounded-lg font-semibold transition-all duration-300 text-center block ${
                pkg.popular
                  ? 'bg-brand-orange text-white hover:bg-brand-blue'
                  : 'bg-brand-blue text-white hover:bg-brand-orange'
              }`}>
                Get Started
              </Link>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Need a Custom Package?
          </h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            We can create a custom package tailored to your specific needs and budget.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-brand-blue text-white px-8 py-3 rounded-lg font-semibold hover:bg-brand-orange transition-all duration-300 text-center">
              Get Custom Quote
            </Link>
            <Link to="/contact" className="bg-white text-brand-blue border-2 border-brand-blue px-8 py-3 rounded-lg font-semibold hover:bg-brand-blue hover:text-white transition-all duration-300 text-center">
              Schedule Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;